<template>
  <div class="orderMain">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="会员列表" name="first"> </el-tab-pane>
      <el-tab-pane label="会员营销" name="second"> </el-tab-pane>
      <el-tab-pane label="会员列表管理" name="three">
        <div>
          <div class="title_div">
            <span class="title-span">门店:</span>
            <el-select
              filterable
              clearable
              v-model="hyParams.shopId"
              size="small"
              class="title-select"
              @change="mdStortChange"
            >
              <el-option
                v-for="item in this.mdSelectList"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
            <span class="title-span">会员等级:</span>
            <el-select
              clearable
              v-model="hyParams.levelId"
              size="small"
              class="title-select"
              @change="djStortChange"
            >
              <el-option
                v-for="item in this.djSelectList"
                :label="item.cardName"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>

            <span class="title-span">归属:</span>
            <el-select
              clearable
              v-model="hyParams.userID"
              size="small"
              class="title-select"
              filterable
              remote
              :loading="loading"
              :remote-method="remoteMethod"
              @change="dyStortChange"
            >
              <el-option
                v-for="item in this.gsSelectList"
                :label="item.realname"
                :value="item.userId"
                :key="item.userId"
              ></el-option>
            </el-select>
            <br />
            <span class="title-span">开卡时间:</span>
            <el-date-picker
              @change="hyStartChange"
              v-model="hyParams.createDateStart"
              size="small"
              class="title-date1"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择开始日期"
            >
            </el-date-picker>
            至
            <el-date-picker
              @change="hyEndChange"
              v-model="hyParams.createDateEnd"
              size="small"
              class="title-date2"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择结束日期"
            >
            </el-date-picker>
            <span class="title-span">会员:</span>
            <el-input
              size="small"
              style="width: 200px; margin-left: 20px; margin-top: 20px"
              v-model="hyParams.queryValue"
              placeholder="会员电话、姓名、会员卡号"
              clearable
              @input="hyMemberInfo"
            ></el-input>
          </div>
          <div style="text-align: right">
            <el-button
              class="creat-button"
              type="primary"
              size="small"
              @click="creatHy"
              >新建会员
            </el-button>
            <el-button
              class="out-button"
              type="primary"
              size="small"
              @click="copyAll"
              >批量导出</el-button
            >
          </div>
          <div class="mm-tb">
            <el-table :data="hyList" style="width: 100%">
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="80"
              >
              </el-table-column>
              <el-table-column
                prop="memberName"
                label="会员姓名"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="medium"
                    @click="editHy(scope.row.id)"
                    >{{ scope.row.memberName }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column
                prop="memberMobile"
                label="手机号码"
                align="center"
                width="200"
              >
              </el-table-column>
              <el-table-column prop="levelName" label="会员等级" align="center">
              </el-table-column>
              <el-table-column prop="points" label="会员积分" align="center">
              </el-table-column>
              <el-table-column prop="shopName" label="门店" align="center">
              </el-table-column>
              <el-table-column
                prop="createUserName"
                label="归属人"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="address" label="开卡日期" align="center">
                <template slot-scope="scope">{{
                  scope.row.createDate.substring(0, 10)
                }}</template>
              </el-table-column>
              <el-table-column prop="address" align="center" label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="medium"
                    @click="copyOne(scope.row)"
                    >复制</el-button
                  >
                  <el-button
                    v-if="roleCode === 'operation'"
                    type="text"
                    size="medium"
                    @click="deleteMembers(scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination
              class="mm-page"
              @size-change="hySizeChange"
              @current-change="hyCurrentChange"
              :current-page="hyResult.current"
              :page-size="hyResult.size"
              layout="total,prev, pager, next, sizes"
              :total="hyResult.total"
              :page-sizes="[10, 20, 30, 40, 50]"
            >
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      title="会员录入"
      :visible.sync="creathyDialogVisible"
      width="940px"
      :close-on-click-modal="false"
    >
      <div class="clearfix">
        <div class="leftDiv" style="float: left">
          <div class="dialog-div">
            <span class="title-span">会 员 卡 号:</span>
            <el-input
              size="small"
              class="title-select"
              v-model="hyCreatParams.memberCardSn"
            ></el-input>
          </div>
          <div class="dialog-div">
            <span class="title-span">会 员 姓 名:</span>
            <el-input
              size="small"
              class="title-select"
              v-model="hyCreatParams.memberName"
            ></el-input>
          </div>
          <div class="dialog-div">
            <span class="title-span"
              >手&nbsp;&nbsp;&nbsp;机&nbsp;&nbsp;&nbsp;号:</span
            >
            <el-input
              size="small"
              class="title-select"
              v-model="hyCreatParams.memberMobile"
            ></el-input>
          </div>
          <div class="dialog-div">
            <span class="title-span">出 生 日 期:</span>
            <!--            <el-input size="small" class="title-select" v-model="hyCreatParams.memberBirthday"></el-input>-->
            <el-date-picker
              type="date"
              size="small"
              class="title-select"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              v-model="hyCreatParams.memberBirthday"
            ></el-date-picker>
          </div>
          <div class="dialog-div">
            <span class="title-span">身 份 证 号:</span>
            <el-input
              size="small"
              class="title-select"
              v-model="hyCreatParams.memberSfnum"
            ></el-input>
          </div>
          <div class="dialog-div">
            <span class="title-span">所 在 门 店:</span>
            <el-select
              clearable
              v-model="hyCreatParams.shopId"
              size="small"
              class="title-select"
              placeholder="请选择门店"
              @change="getUserByShop"
            >
              <el-option
                v-for="item in this.mdSelectList"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="dialog-div">
            <span class="title-span">会 员 等 级:</span>
            <el-select
              clearable
              v-model="hyCreatParams.levelId"
              placeholder="请选择会员等级"
              size="small"
              class="title-select"
            >
              <el-option
                v-for="item in djSelectList"
                :key="item.id"
                :label="item.cardName"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="dialog-div">
            <span class="title-span"
              >储&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;值:</span
            >
            <el-input
              size="small"
              class="title-select"
              v-model="hyCreatParams.balance"
              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            ></el-input>
          </div>
          <div class="dialog-div">
            <span class="title-span"
              >赠&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;储:</span
            >
            <el-input
              size="small"
              class="title-select"
              v-model="hyCreatParams.giveStore"
              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            ></el-input>
          </div>
          <div class="dialog-div">
            <span class="title-span"
              >电&nbsp;&nbsp;&nbsp;子&nbsp;&nbsp;&nbsp;卡:
            </span>
            <el-input
              size="small"
              class="title-select"
              v-model="hyCreatParams.electronicCard"
              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            ></el-input>
          </div>
        </div>
        <div class="rightDiv" style="float: left">
          <div class="dialog-div clearfix">
            <span class="title-span" style="float: left">会 员 照 片:</span>
            <el-upload
              style="float: left"
              class="avatar-uploader"
              accept=".png,.jpg,.jpeg,.JPG,.JPEG"
              :headers="headers"
              :action="upLoadUrl"
              :show-file-list="false"
              :on-success="creatHandleAvatarSuccess"
              :before-upload="creatBeforeAvatarUpload"
            >
              <img v-if="creatImageUrl" :src="creatImageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div class="dialog-div">
            <span class="title-span">所 属 教 练:</span>
            <el-select
              clearable
              v-model="hyCreatParams.createUserId"
              size="small"
              class="title-select"
              placeholder="请选择教练"
            >
              <el-option
                v-for="item in this.jlSelectList"
                :label="item.realname"
                :value="item.userId"
                :key="item.userId"
              ></el-option>
            </el-select>
          </div>
          <div class="dialog-div">
            <span class="title-span"
              >积&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;分:</span
            >
            <el-input
              size="small"
              class="title-select"
              v-model="hyCreatParams.points"
              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            ></el-input>
          </div>
          <div class="dialog-div">
            <span class="title-span"
              >能&nbsp;&nbsp;&nbsp;量&nbsp;&nbsp;&nbsp;值:</span
            >
            <el-input
              size="small"
              class="title-select"
              v-model="hyCreatParams.power"
              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            ></el-input>
          </div>
          <div class="dialog-div">
            <span class="title-span"
              >箭&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;票:</span
            >
            <el-input
              size="small"
              class="title-select"
              v-model="hyCreatParams.arrowTicket"
              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            ></el-input>
          </div>
          <div class="dialog-div">
            <!-- <span class="title-span">剩 余 天 数:</span>
            <el-input
              size="small"
              class="title-select"
              v-model="hyCreatParams.electronicCardDays"
              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            ></el-input> -->
            <span class="title-span">箭票有效期:</span>
            <el-date-picker
              v-model="hyCreatParams.arrowTicketEndDate"
              type="date"
              placeholder="选择日期"
              size="small"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              class="title-select"
            >
            </el-date-picker>
          </div>
        </div>
      </div>

      <div class="dialog-div clearfix">
        <span class="title-span" style="float: left">会 员 荣 誉:</span>
        <el-checkbox-group
          v-model="creatHonours"
          size="mini"
          style="float: left; margin-left: 20px"
        >
          <el-checkbox-button
            v-for="item in vipHonor"
            :label="item.id"
            :key="item.id"
            >{{ item.honourName }}
          </el-checkbox-button>
        </el-checkbox-group>
      </div>
      <div class="dialog-div clearfix">
        <span class="title-span" style="float: left">会 员 备 注:</span>
        <el-input
          type="textarea"
          style="float: left; margin-left: 20px; width: 600px"
          v-model="hyCreatParams.remark"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="creathyDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="creathyCommit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="会员编辑"
      :visible.sync="edithyDialogVisible"
      width="940px"
      :close-on-click-modal="false"
    >
      <div class="clearfix">
        <div class="leftDiv" style="float: left">
          <div class="dialog-div">
            <span class="title-span">会 员 卡 号:</span>
            <el-input
              size="small"
              class="title-select"
              v-model="hyEditParams.memberCardSn"
            ></el-input>
          </div>
          <div class="dialog-div">
            <span class="title-span">会 员 姓 名:</span>
            <el-input
              size="small"
              class="title-select"
              v-model="hyEditParams.memberName"
            ></el-input>
          </div>
          <div class="dialog-div">
            <span class="title-span"
              >手&nbsp;&nbsp;&nbsp;机&nbsp;&nbsp;&nbsp;号:</span
            >
            <el-input
              size="small"
              class="title-select"
              v-model="hyEditParams.memberMobile"
            ></el-input>
          </div>
          <div class="dialog-div">
            <span class="title-span">出 生 日 期:</span>
            <el-date-picker
              type="date"
              size="small"
              class="title-select"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              v-model="hyEditParams.memberBirthday"
            ></el-date-picker>
          </div>
          <div class="dialog-div">
            <span class="title-span">身 份 证 号:</span>
            <el-input
              size="small"
              class="title-select"
              v-model="hyEditParams.memberSfnum"
            ></el-input>
          </div>
          <div class="dialog-div">
            <span class="title-span">所 在 门 店:</span>
            <el-select
              clearable
              v-model="hyEditParams.shopId"
              size="small"
              class="title-select"
              placeholder="请选择门店"
              @change="getUserByShop"
            >
              <el-option
                v-for="item in this.mdSelectList"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="dialog-div">
            <span class="title-span">会 员 等 级:</span>
            <el-select
              clearable
              v-model="hyEditParams.levelId"
              placeholder="请选择会员等级"
              size="small"
              class="title-select"
            >
              <el-option
                v-for="item in djSelectList"
                :key="item.id"
                :label="item.cardName"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="dialog-div">
            <span class="title-span"
              >储&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;值:</span
            >
            <el-input
              size="small"
              class="title-select"
              v-model="hyEditParams.balance"
              onkeyup="this.value=this.value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'')"
            ></el-input>
          </div>
          <div class="dialog-div">
            <span class="title-span"
              >赠&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;储:</span
            >
            <!-- onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}" -->
            <el-input
              size="small"
              class="title-select"
              v-model="hyEditParams.giveStore"
              onkeyup="this.value=this.value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'')"
            ></el-input>
          </div>
          <div class="dialog-div">
            <span class="title-span"
              >电&nbsp;&nbsp;&nbsp;子&nbsp;&nbsp;&nbsp;卡:
            </span>
            <el-input
              size="small"
              class="title-select"
              v-model="hyEditParams.electronicCard"
              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            ></el-input>
          </div>
          <div class="dialog-div">
            <span class="title-span">电子卡有效期:</span>
            <el-date-picker
              v-model="hyEditParams.electronicCardEndDate"
              type="date"
              placeholder="选择日期"
              size="small"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              class="title-select"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="rightDiv" style="float: left">
          <div class="dialog-div clearfix">
            <span class="title-span" style="float: left">会 员 照 片:</span>
            <el-upload
              style="float: left"
              class="avatar-uploader"
              accept=".png,.jpg,.jpeg,.JPG,.JPEG"
              :headers="headers"
              :action="upLoadUrl"
              :show-file-list="false"
              :on-success="editHandleAvatarSuccess"
              :before-upload="editBeforeAvatarUpload"
            >
              <img v-if="editImageUrl" :src="editImageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div class="dialog-div">
            <span class="title-span">所 属 教 练:</span>
            <el-select
              clearable
              v-model="hyEditParams.createUserId"
              size="small"
              class="title-select"
              placeholder="请选择教练"
            >
              <el-option
                v-for="item in this.jlSelectList"
                :label="item.realname"
                :value="item.userId"
                :key="item.userId"
              ></el-option>
            </el-select>
          </div>
          <div class="dialog-div">
            <span class="title-span"
              >积&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;分:</span
            >
            <el-input
              size="small"
              class="title-select"
              v-model="hyEditParams.points"
              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            ></el-input>
          </div>
          <div class="dialog-div">
            <span class="title-span"
              >能&nbsp;&nbsp;&nbsp;量&nbsp;&nbsp;&nbsp;值:</span
            >
            <el-input
              size="small"
              class="title-select"
              v-model="hyEditParams.power"
              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            ></el-input>
          </div>
          <div class="dialog-div">
            <span class="title-span"
              >箭&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;票:</span
            >
            <el-input
              size="small"
              class="title-select"
              v-model="hyEditParams.arrowTicket"
              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            ></el-input>
          </div>
          <div class="dialog-div">
            <!-- <span class="title-span">剩 余 天 数:</span>
            <el-input
              size="small"
              class="title-select"
              v-model="hyEditParams.electronicCardDays"
              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            ></el-input> -->
            <span class="title-span">箭票有效期:</span>
            <el-date-picker
              v-model="hyEditParams.arrowTicketEndDate"
              type="date"
              placeholder="选择日期"
              size="small"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              class="title-select"
            >
            </el-date-picker>
          </div>
        </div>
      </div>

      <div class="dialog-div clearfix">
        <span class="title-span" style="float: left">会 员 荣 誉:</span>
        <el-checkbox-group
          v-model="editHonours"
          size="mini"
          style="float: left; margin-left: 20px"
        >
          <el-checkbox-button
            v-for="item in vipHonor"
            :label="item.id"
            :key="item.id"
            >{{ item.honourName }}
          </el-checkbox-button>
        </el-checkbox-group>
      </div>

      <div class="dialog-div clearfix">
        <span class="title-span" style="float: left">新 老 资 费:</span>
        <el-radio-group
          v-model="hyEditParams.newOldMemberLogo"
          size="mini"
          style="float: left; margin-left: 20px"
        >
          <el-radio-button :label="'0'">新资费</el-radio-button>
          <el-radio-button :label="'1'">老资费</el-radio-button>
        </el-radio-group>
      </div>
      <div class="dialog-div clearfix">
        <span class="title-span" style="float: left">会 员 备 注:</span>
        <el-input
          type="textarea"
          style="float: left; margin-left: 20px; width: 600px"
          v-model="hyEditParams.remark"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="edithyDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="edithyCommit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { globelurl, posturl } from "../../api/axios";
import {
  getAntMembersPage,
  getUserForSelect,
  addAntMembers,
  getAntMembersForExcel,
  getCoachListForSelect,
} from "../../api/MemberManagement";
import {
  getAntDeptSelect,
  getMembersCardLevelSelect,
  getHonourList,
  addUser,
  getAntMemberById,
  updateMember,
  deleteMembers,
} from "../../api/BusinessManagement";

export default {
  name: "MemberLlistManagement",
  data() {
    return {
      activeName: "three",
      hyParams: {
        createDateStart: "",
        createDateEnd: "",
        shopId: "",
        levelId: "",
        userID: "",
        pageNo: 1,
        pageSize: 10,
        queryValue: "",
      },
      hyCreatParams: {
        memberCardSn: "",
        memberName: "",
        memberMobile: "",
        memberBirthday: "",
        memberSfnum: "",
        shopId: "",
        levelId: "",
        balance: "",
        giveStore: "",
        electronicCard: "",
        photoData: "",
        createUserId: "",
        points: "",
        power: "",
        arrowTicket: "",
        electronicCardDays: "",
        honourIds: "",
        remark: "",
      },
      hyEditParams: {
        memberCardSn: "",
        id: "",
        memberName: "",
        memberMobile: "",
        memberBirthday: "",
        memberSfnum: "",
        shopId: "",
        levelId: "",
        balance: "",
        giveStore: "",
        electronicCard: "",
        photoData: "",
        createUserId: "",
        points: "",
        power: "",
        arrowTicket: "",
        electronicCardDays: "",
        honourIds: "",
        remark: "",
        electronicCardEndDate: "",
        arrowTicketEndDate: "",
        newOldMemberLogo: "",
      },
      creatHonours: [],
      editHonours: [],
      hyResult: {},
      hyList: [],
      mdSelectList: [],
      jlSelectList: [],
      djSelectList: [],
      creathyDialogVisible: false,
      edithyDialogVisible: false,
      headers: { "X-Access-Token": sessionStorage.token },
      upLoadUrl: posturl,
      creatImageUrl: "",
      editImageUrl: "",
      vipHonor: [],
      gsSelectList: [],
      loading: false,
      roleCode: sessionStorage.roleCode,
    };
  },
  mounted() {
    this.getAntMembersPage(this.hyParams);
    this.getAntDeptSelect();
    this.getMembersCardLevelSelect();
    this.getHonourList();
    this.getUserByShopSearch();
  },
  methods: {
    handleClick(tab, event) {
      if (tab.label == "会员列表") {
        this.$router.push("/MemberManagement/MemberLlist");
      } else if (tab.label == "会员营销") {
        this.$router.push("/MemberManagement/MemberMarketing");
      } else if (tab.label == "会员列表管理") {
      }
    },
    //获取会员列表
    getAntMembersPage(params) {
      getAntMembersPage(params).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.hyResult = res.data.result;
            this.hyList = res.data.result.records;
          } else {
            this.hyResult = res.data.result;
            this.hyList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //新建会员图片上传
    creatHandleAvatarSuccess(res, file) {
      this.hyCreatParams.photoData = res.result.pathList[0];
      this.creatImageUrl = globelurl + res.result.pathList[0];
    },
    creatBeforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    hySizeChange(newSize) {
      this.hyParams.pageSize = newSize;
      this.getAntMembersPage(this.hyParams);
    },
    hyCurrentChange(newPage) {
      this.hyParams.pageNo = newPage;
      this.getAntMembersPage(this.hyParams);
    },
    //获取门店下拉菜单
    getAntDeptSelect() {
      getAntDeptSelect().then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.mdSelectList = res.data.result;
          }
        }
      });
    },
    //门店下拉菜单改变
    mdStortChange(val) {
      this.hyParams.pageNo = 1;
      this.getAntMembersPage(this.hyParams);
      // this.getUserByShopSearch(val);
    },
    //获取筛选归属人
    getUserByShopSearch() {
      //  getUserForSelect({ shopId: shopId }).then((res) => {
      getUserForSelect({ queryAll: 1 }).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.gsSelectList = res.data.result;
          }
        }
      });
    },
    //获取会员等级下拉列表
    getMembersCardLevelSelect() {
      getMembersCardLevelSelect().then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.djSelectList = res.data.result;
          }
        }
      });
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          getCoachListForSelect({ queryValue: query }).then((res) => {
            if (res.status === 200 && res.data.success) {
              this.gsSelectList = res.data.result;
            }
          });
        }, 200);
      } else {
        this.gsSelectList = [];
      }
    },
    //会员等级下拉菜单改变
    djStortChange(val) {
      this.hyParams.pageNo = 1;
      this.getAntMembersPage(this.hyParams);
    },
    //店员筛选下拉
    dyStortChange(val) {
      if (val === "") {
        this.getUserByShopSearch();
      }
      this.hyParams.pageNo = 1;
      this.getAntMembersPage(this.hyParams);
    },
    // 会员模糊搜索
    hyMemberInfo() {
      this.hyParams.pageNo = 1;
      this.getAntMembersPage(this.hyParams);
    },
    //店员下拉
    getUserByShop(shopId) {
      getUserForSelect({ shopId: shopId }).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.jlSelectList = res.data.result;
          }
        }
      });
    },
    //会员开始时间改变
    hyStartChange() {
      if (
        this.hyParams.createDateStart &&
        this.hyParams.createDateEnd &&
        new Date(this.hyParams.createDateStart).getTime() >
          new Date(this.hyParams.createDateEnd).getTime()
      ) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.hyParams.pageNo = 1;
      this.getAntMembersPage(this.hyParams);
    },
    //会员结束时间改变
    hyEndChange() {
      if (
        this.hyParams.createDateStart &&
        this.hyParams.createDateEnd &&
        new Date(this.hyParams.createDateStart).getTime() >
          new Date(this.hyParams.createDateEnd).getTime()
      ) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.hyParams.pageNo = 1;
      this.getAntMembersPage(this.hyParams);
    },
    //荣誉列表
    getHonourList() {
      getHonourList().then((res) => {
        if (res.status === 200 && res.data.success) {
          this.vipHonor = res.data.result;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    creatHy() {
      this.creathyDialogVisible = true;
      this.hyCreatParams.memberCardSn = "";
      this.hyCreatParams.memberName = "";
      this.hyCreatParams.memberMobile = "";
      this.hyCreatParams.memberBirthday = "";
      this.hyCreatParams.memberSfnum = "";
      this.hyCreatParams.shopId = "";
      this.hyCreatParams.levelId = "";
      this.hyCreatParams.balance = "";
      this.hyCreatParams.giveStore = "";
      this.hyCreatParams.electronicCard = "";
      this.hyCreatParams.createUserId = "";
      this.hyCreatParams.points = "";
      this.hyCreatParams.power = "";
      this.hyCreatParams.arrowTicket = "";
      this.hyCreatParams.electronicCardDays = "";
      this.hyCreatParams.remark = "";
      this.hyCreatParams.photoData = "";
      this.creatHonours = [];
      this.creatImageUrl = "";
    },
    //新建会员
    creathyCommit() {
      var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
      if (!phonereg.test(this.hyCreatParams.memberMobile)) {
        this.$message.error("请输入正确手机号码");
      } else if (this.hyCreatParams.memberName == "") {
        this.$message.error("请输入会员姓名");
      } else if (this.hyCreatParams.memberMobile == "") {
        this.$message.error("请输入会员联系方式");
      } else if (this.hyCreatParams.memberBirthday == "") {
        this.$message.error("请选择会员生日");
      } else if (this.hyCreatParams.levelId == "") {
        this.$message.error("请选择会员等级");
      } else {
        this.hyCreatParams.honourIds = this.creatHonours.join(",");
        // console.log(this.hyCreatParams)
        addAntMembers(this.hyCreatParams).then((res) => {
          if (res.status === 200 && res.data.success) {
            if (res.data.result.total === 0) {
              this.$Notice.open({
                title: "查无数据",
              });
            } else {
              this.$message.success("新建成功");
              this.creathyDialogVisible = false;
              this.getAntMembersPage(this.hyParams);
            }
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    //复制一条
    copyOne(r) {
      //console.log(r)
      var text =
        "会员姓名:" +
        r.memberName +
        ";手机号码:" +
        r.memberMobile +
        ";会员等级:" +
        r.levelName +
        ";会员积分:" +
        r.points +
        ";门店:" +
        r.shopName +
        ";归属人:" +
        r.createUserName +
        ";开卡日期:" +
        r.createDate.substring(0, 10);
      this.copyText(text);
    },
    //获取文字到粘贴板
    copyText(text) {
      var textarea = document.createElement("input"); //创建input对象
      var currentFocus = document.activeElement; //当前获得焦点的元素
      document.body.appendChild(textarea); //添加元素
      textarea.value = text;
      textarea.focus();
      if (textarea.setSelectionRange) {
        textarea.setSelectionRange(0, textarea.value.length);
      } //获取光标起始位置到结束位置
      else {
        textarea.select();
      }
      try {
        var flag = document.execCommand("copy"); //执行复制
      } catch (eo) {
        var flag = false;
      }
      document.body.removeChild(textarea); //删除元素
      currentFocus.focus();
      //console.log(flag)
      if (flag) {
        this.$message.success("复制数据成功！");
      } else {
        this.$message.error(res.message);
      }
      return flag;
    },
    //批量导出
    copyAll() {
      // getAntMembersForExcel({pageNo: this.hyParams.pageNo, pageSize: this.hyParams.pageSize}).then(res => {
      const params = { ...this.hyParams };
      // delete params.createDateStart
      // delete params.createDateEnd
      // delete params.shopId
      // delete params.levelId
      // delete params.userID
      getAntMembersForExcel(params).then((res) => {
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        downloadElement.download = "会员列表"; // sessionStorage.realName + timestr　　　　　　　　// xxx.xls/xxx.xlsx
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href);
      });
      // })
    },
    // 回显
    editHy(userID) {
      getAntMemberById({ id: userID }).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.edithyDialogVisible = true;
            this.hyEditParams.memberCardSn = res.data.result.memberCardSn;
            this.hyEditParams.id = res.data.result.id;
            this.hyEditParams.memberName = res.data.result.memberName;
            this.hyEditParams.memberMobile = res.data.result.memberMobile;
            this.hyEditParams.memberBirthday = res.data.result.memberBirthday;
            this.hyEditParams.memberSfnum = res.data.result.memberSfnum;
            this.hyEditParams.shopId = res.data.result.shopId;
            this.getUserByShop(res.data.result.shopId);
            this.hyEditParams.electronicCardEndDate =
              res.data.result.electronicCardEndDate;
            this.hyEditParams.arrowTicketEndDate =
              res.data.result.arrowTicketEndDate;
            this.hyEditParams.createUserId = res.data.result.createUserId;
            this.hyEditParams.levelId = res.data.result.antMembersCardLevel.id;
            this.hyEditParams.remark = res.data.result.remark;
            this.hyEditParams.points = res.data.result.points;
            this.hyEditParams.balance = res.data.result.balance;
            this.hyEditParams.power = res.data.result.power;
            this.hyEditParams.arrowTicket = res.data.result.arrowTicket;
            this.hyEditParams.giveStore = res.data.result.giveStore;
            this.hyEditParams.electronicCard = res.data.result.electronicCard;
            this.hyEditParams.electronicCardDays =
              res.data.result.electronicCardDays;
            this.editImageUrl = globelurl + res.data.result.photoData;
            this.hyEditParams.photoData = res.data.result.photoData;
            this.hyEditParams.newOldMemberLogo = res.data.result
              .newOldMemberLogo
              ? res.data.result.newOldMemberLogo
              : "";
            this.editHonours = res.data.result.honourIds
              ? res.data.result.honourIds.split(",")
              : [];
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //编辑会员图片上传
    editHandleAvatarSuccess(res, file) {
      this.hyEditParams.photoData = res.result.pathList[0];
      this.editImageUrl = globelurl + res.result.pathList[0];
    },
    editBeforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    //编辑会员提交
    edithyCommit() {
      // var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
      // if (!phonereg.test(this.hyEditParams.memberMobile)) {
      //   this.$message.error("请输入正确手机号码");
      // } else
      if (this.hyEditParams.memberName == "") {
        this.$message.error("请输入会员姓名");
      } else if (this.hyEditParams.memberMobile == "") {
        this.$message.error("请输入会员联系方式");
      } else if (this.hyEditParams.memberBirthday == "") {
        this.$message.error("请选择会员生日");
      } else if (this.hyEditParams.levelId == "") {
        this.$message.error("请选择会员等级");
      } else {
        this.hyEditParams.honourIds = this.editHonours.join(",");
        // console.log(this.hyCreatParams)
        updateMember(this.hyEditParams)
          .then((res) => {
            if (res.status === 200 && res.data.success) {
              if (res.data.result.total === 0) {
                this.$Notice.open({
                  title: "查无数据",
                });
              } else {
                this.$message.success("编辑账号成功");
                this.edithyDialogVisible = false;
                this.getAntMembersPage(this.hyParams);
              }
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch((e) => {
            this.$message.error("提交失败，请联系管理员");
          });
      }
    },
    deleteMembers(row) {
      this.$confirm("此操作将永久删除该会员, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteMembers({ id: row.id }).then((res) => {
            if (res.data.success) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getAntMembersPage(this.hyParams);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style scoped>
.title-span {
  font-size: 16px;
}

.title_div {
  margin: 20px 30px;
}

.title-select {
  margin: 0 20px;
  width: 200px;
}

.title-date1 {
  margin-left: 20px;
  width: 180px;
}

.title-date2 {
  width: 180px;
  margin-right: 20px;
}

.dialog-div {
  margin: 20px 0;
}

.creat-button {
  margin: 20px;
}

.out-button {
  margin-top: 20px;
  margin-right: 80px;
  margin-bottom: 20px;
}

.mm-tb {
  width: 90%;
  margin-left: 50px;
}

.mm-page {
  margin: 30px 60px;
}

.leftDiv {
  width: 50%;
  display: inline-block;
}

.rightDiv {
  width: 50%;
  display: inline-block;
}

.orderMain {
  padding: 30px;
}
</style>

<style>
.el-upload {
  border: 1px dashed #d9d9d9;
  margin-left: 20px;
}

.el-dialog__body {
  padding: 0 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
